// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed","826":"text","946":"dynamic-content"}[chunkId] + "." + {"180":"aba8e2f5506e5c99356f","303":"b57471ba20e50283a7a7","495":"ab93e1ec1bb2074c654d","826":"3f36bb69fe2d911b4be8","946":"05fb92968e05c2a89a6a"}[chunkId] + ".js";
};